var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "subscription-plan-view" }, [
    _vm.isDialogView
      ? _c(
          "button",
          {
            staticClass: "button-close",
            attrs: { role: "button" },
            on: { click: _vm.closeView },
          },
          [_c("img", { attrs: { src: "/assets/app/class/icon-close.svg" } })]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "plan-view-header",
        class: { "with-banner": _vm.isBannerVisisbleWithoutTitle },
      },
      [
        _vm.tableOptions.show_title && !_vm.pricingTable
          ? _c("div", { staticClass: "pricing-table-title" }, [
              _c("h2", { staticClass: "view-title" }, [
                _vm._v(_vm._s(_vm.tableOptions.title)),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "description" }, [
                _vm._v(_vm._s(_vm.tableOptions.sub_title)),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.tableOptions.banner_image_url && !_vm.pricingTable
          ? _c("div", { staticClass: "pricing-table-title" }, [
              _c("img", {
                staticClass: "pricing-custom-banner",
                attrs: { src: _vm.tableOptions.banner_image_url },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("rt-switch-input", {
          attrs: { priceMode: true },
          model: {
            value: _vm.priceYearly,
            callback: function ($$v) {
              _vm.priceYearly = $$v
            },
            expression: "priceYearly",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "plan-view-main" },
      _vm._l(_vm.subscriptionPlans, function (pricingPlan, pIdx) {
        return _vm.isPlanVisible(pricingPlan.type, pIdx)
          ? _c(
              "div",
              {
                key: pIdx,
                staticClass: "subscription-card",
                class: { "custom-plan": _vm.plansCount <= 3 },
              },
              [
                _vm.isPopularPlan(pricingPlan.identifier)
                  ? _c("img", {
                      staticClass: "icon-popular",
                      attrs: { src: "/assets/app/class/icon-popular.svg" },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "subscription-header" }, [
                  _c("img", {
                    staticClass: "plan-icon",
                    attrs: { src: _vm.pricingPlanIcon(pricingPlan) },
                  }),
                  _vm._v(" "),
                  _c("h2", { staticClass: "subscription-title" }, [
                    _vm._v(_vm._s(_vm.pricingPlanName(pricingPlan))),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "subscription-content",
                    class: {
                      inifinte: _vm.isCustomPlan(pricingPlan.type),
                      "slide-content": _vm.isSliderView,
                    },
                  },
                  [
                    _c("div", { staticClass: "subscription-price" }, [
                      !_vm.isCustomPlan(pricingPlan.type)
                        ? _c("div", { staticClass: "current-amount-wrapper" }, [
                            !_vm.isMaxStudents(pricingPlan)
                              ? _c("span", { staticClass: "price-symbol" }, [
                                  _vm._v("$"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isNewSliderPlan(pricingPlan)
                              ? _c("span", { staticClass: "amount-value" }, [
                                  _vm._v(
                                    _vm._s(_vm.getAdjustableAmount(pricingPlan))
                                  ),
                                ])
                              : _c("span", { staticClass: "amount-value" }, [
                                  _vm._v(_vm._s(_vm.getAmount(pricingPlan))),
                                ]),
                            _vm._v(" "),
                            !_vm.isMaxStudents(pricingPlan)
                              ? _c("span", { staticClass: "price-symbol" }, [
                                  _vm._v("/ " + _vm._s(_vm.planAmountSuffix)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.getDiscountAmount(pricingPlan)
                              ? _c("span", { staticClass: "discount-amount" }, [
                                  _vm._v(
                                    "$" +
                                      _vm._s(_vm.getDiscountAmount(pricingPlan))
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _c("img", {
                            staticClass: "icon-infinite",
                            attrs: {
                              src: "/assets/app/class/icon-infinite-rocket.svg",
                            },
                          }),
                    ]),
                    _vm._v(" "),
                    _vm.isNewSliderPlan(pricingPlan)
                      ? _c("p", { staticClass: "plan-descripion" }, [
                          _vm._v(
                            _vm._s(_vm.adjustablePlanDescription(pricingPlan))
                          ),
                        ])
                      : _c("p", { staticClass: "plan-descripion" }, [
                          _vm._v(_vm._s(_vm.planDescription(pricingPlan))),
                        ]),
                    _vm._v(" "),
                    _vm.isNewSliderPlan(pricingPlan)
                      ? _c(
                          "div",
                          { staticClass: "subscription-student-count-slider" },
                          [
                            _c("vue-slider", {
                              ref: "slider",
                              refInFor: true,
                              attrs: {
                                min: 30,
                                max: 100,
                                "dot-options": { tooltip: "always" },
                                "tooltip-placement": "top",
                                interval: 10,
                              },
                              model: {
                                value: _vm.studentCounterSlider,
                                callback: function ($$v) {
                                  _vm.studentCounterSlider = $$v
                                },
                                expression: "studentCounterSlider",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isSliderView
                      ? _c(
                          "div",
                          {
                            staticClass: "subscription-action",
                            class: {
                              popular: pricingPlan.identifier === "2",
                              "new-slider":
                                (_vm.isFreePlan(pricingPlan.type) ||
                                  _vm.isCustomPlan(pricingPlan.type)) &&
                                _vm.isNewSliderView(pricingPlan),
                            },
                          },
                          [
                            _c(
                              "primary-button",
                              {
                                class: _vm.isCustomPlan(pricingPlan.type)
                                  ? "trigger-quote-chat"
                                  : "",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleUpgradePlan(pricingPlan)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "btn-action-title" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.pricingActionTitle(pricingPlan)
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.upgradingStatus &&
                                _vm.upgradingStatus[pricingPlan.identifier]
                                  ? _c("div", {
                                      staticClass: "loading-spinner",
                                    })
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.priceYearly && !_vm.isFreePlan(pricingPlan.type)
                              ? _c("p", { staticClass: "yearly-disclaimer" }, [
                                  _vm._v("*when billed annually"),
                                ])
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "features-list" },
                      [
                        pricingPlan.before_features_text
                          ? _c("p", { staticClass: "pre-features" }, [
                              _vm._v(_vm._s(pricingPlan.before_features_text)),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(
                          _vm.pricingFeatures(pricingPlan),
                          function (featureDesc, idx) {
                            return _c("li", { key: idx }, [
                              _c("img", {
                                attrs: {
                                  src: "/assets/app/class/icon-check-blue.svg",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "feature-description" },
                                [_vm._v(_vm._s(featureDesc))]
                              ),
                            ])
                          }
                        ),
                      ],
                      2
                    ),
                  ]
                ),
              ]
            )
          : _vm._e()
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }